import styled from 'styled-components/macro';
import { hideVisually } from 'polished';

const borderWidth = 3;
const ItemImageDimension = 45;

export const Container = styled.div`
  display: flex;
`;

/**
 * Selected image
 */
export const SelectedImageContainer = styled.div`
  flex-basis: 20%;
  margin-right: 20px;
`;

export const SelectedImage = styled.img`
  flex-basis: 100%;
  max-width: 100%;
  flex: 0 0 auto;
  min-width: 100px;
`;

export const ItemsContainer = styled.div`
  flex-basis: 80%;
  margin: -${borderWidth * 2}px -${borderWidth * 2}px 0; /* NOTE: margin-top is equal to border-width */
  font-size: 0;
`;

/**
 * Item
 */
export const ItemRadio = styled.input`
  ${hideVisually};

  &:checked + label > img,
  &:hover + label > img {
    border-color: ${({ theme }) => theme.Grey};
  }
`;

export const ItemLabel = styled.label`
  display: inline-block;
  max-width: calc(100% / 6);
  padding: ${borderWidth}px;
  min-width: ${ItemImageDimension + borderWidth * 2}px;
`;

export const ItemImage = styled.img`
  border: ${borderWidth}px solid transparent;
  transition: ${({ theme }): string =>
    `border-color ${theme.transitionDuration} ${theme.timingFunction}`};
`;
